export default __webpack_public_path__ + "static/media/rebate-guy.3606818e.svg";